<template>
  <div style="height: 100%">
    <v-container v-if="loading">
      <v-layout justify-center>
        <v-progress-circular size="50" indeterminate />
      </v-layout>
      <v-layout class="mt-3" justify-center>
        <span class="subheading"> Loading your layout... </span>
      </v-layout>
    </v-container>
    <grid-layout
      v-show="!loading"
      :col-num="24"
      :layout="layout"
      :row-height="10"
      :vertical-compact="false"
      @layout-updated="layoutUpdated"
    >
      <!-- eslint-disable-next-line vue/max-attributes-per-line -->
      <grid-item
        v-for="(item, index) in layout"
        :h="item.h"
        :i="item.i"
        :key="item.i"
        :w="item.w"
        :x="item.x"
        :y="item.y"
        drag-ignore-from="a, button, i, #map, .clickable"
      >
        <component
          :is="item.i"
          v-bind="properties[index]"
          v-on="events[index]"
        />
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import { GridItem, GridLayout } from "vue-grid-layout";

import AccessNotes from "./Site/AccessNotes.vue";
import BuildInfo from "./Site/BuildInfo.vue";
import Comments from "./Site/Comments.vue";
import Configuration from "./Site/Configuration.vue";
import Contacts from "./Site/Contacts.vue";
import Customers from "./Site/Customers.vue";
import CustomMap from "./Site/Map.vue";
import FloorPlan from "./Site/FloorPlan.vue";
import Id from "./Site/Id.vue";
import Issues from "./Site/Issues.vue";
import Layout from "./Site/Layout.vue";
import Lease from "./Site/Lease.vue";
import Messages from "./Site/Messages.vue";
import NoiseStats from "./Site/NoiseStats.vue";
import Outages from "./Site/Outages.vue";
import ZabbixEvents from "./Site/ZabbixEvents.vue";

export default {
  name: "sites",
  components: {
    AccessNotes,
    BuildInfo,
    Comments,
    Configuration,
    Contacts,
    Customers,
    CustomMap,
    FloorPlan,
    GridItem,
    GridLayout,
    Id,
    Issues,
    Layout,
    Lease,
    Messages,
    NoiseStats,
    Outages,
    ZabbixEvents,
  },
  data() {
    return {
      defaultLayout: [
        { x: 6, y: 23, w: 12, h: 6, i: "access-notes" },
        { x: 6, y: 48, w: 12, h: 20, i: "build-info" },
        { x: 6, y: 205, w: 12, h: 15, i: "comments" },
        { x: 6, y: 190, w: 12, h: 15, i: "configuration" },
        { x: 6, y: 68, w: 12, h: 12, i: "contacts" },
        // { x: 6, y: 168, w: 12, h: 22, i: "customers" },
        { x: 6, y: 6, w: 12, h: 18, i: "custom-map" },
        { x: 6, y: 80, w: 12, h: 18, i: "floor-plan" },
        { x: 6, y: 0, w: 12, h: 6, i: "id" },
        { x: 6, y: 130, w: 12, h: 18, i: "issues" },
        { x: 18, y: 0, w: 6, h: 6, i: "layout" },
        { x: 6, y: 220, w: 12, h: 15, i: "lease" },
        // { x: 6, y: 118, w: 12, h: 12, i: "messages" },
        // { x: 6, y: 98, w: 12, h: 20, i: "noise-stats" },
        { x: 6, y: 148, w: 12, h: 20, i: "zabbix-events" },
        // { x: 6, y: 30, w: 12, h: 18, i: "outages" }
      ],
      loading: true,
      newLayout: [],
      userLayout: [],
    };
  },
  computed: {
    email() {
      const re = /(?:^|; )sitePass(?:=([^;]*))?(?:;|$)/;
      const result = re.exec(document.cookie);
      if (result === null) {
        return "default";
      }
      const [, token] = result;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.accessName;
    },
    events() {
      return this.layout.map((obj) => {
        let evnt = {};
        if (obj.i === "layout") {
          evnt = { refresh: this.refresh };
        }
        return evnt;
      });
    },
    layout() {
      if (this.userLayout.length === 0) {
        return this.defaultLayout;
      }
      return this.defaultLayout.map((obj) => {
        const ind = this.userLayout.map((ul) => ul.i).indexOf(obj.i);
        if (ind > -1) {
          return this.userLayout[ind];
        }
        return obj;
      });
    },
    properties() {
      return this.layout.map((obj) => {
        let props = {};
        if (obj.i === "layout") {
          props = {
            email: this.email,
            "new-layout": this.newLayout,
            "user-layout": this.userLayout,
          };
        }
        return props;
      });
    },
  },
  created() {
    this.$http
      .get(`/api/users/${this.email}/layout`)
      .then((res) => {
        if (res.status === 200) {
          this.userLayout = Array.from(res.data);
        } else {
          this.userLayout = [];
        }
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$router.go(this.$router.currentRoute);
    },
    layoutUpdated(newLayout) {
      this.newLayout = newLayout.map((obj) => {
        delete obj.moved;
        return obj;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Site.vue